import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralASError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';
import { BillableMetric } from 'src/features/billableMetrics/utils/types';
import { BillableMetricFormSchemaValues } from 'src/features/billableMetrics/utils/formSchema';

const RESOURCE = '/subscriptions/billable-metric/:metricId/';

type MutationFnType = typeof mutationFn;

interface DTO extends BillableMetricFormSchemaValues {
    metricId: string;
}
const mutationFn = ({ metricId, ...data }: DTO): Promise<BillableMetric> => {
    return axios.put(formatResourcePath(RESOURCE, { metricId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateBillableMetric };
